<template>
  <vs-card>
    <div slot="header">Empleos</div>
    <vs-table stripe :data="jobs">
      <template slot="thead" class="thead-dark">
        <vs-th>Salario mensual</vs-th>
        <vs-th>Puesto</vs-th>
        <vs-th>Fecha último día empleo</vs-th>
      </template>
      <template slot-scope="{data}">
        <vs-tr
          :key="job.id"
          v-for="job in data">
          <vs-td>{{job.salarioMensual|currency}}</vs-td>
          <vs-td>{{job.puesto}}</vs-td>
          <vs-td>{{job.fechaUltimoDiaEmpleo}}</vs-td>
        </vs-tr>
      </template>
    </vs-table>
  </vs-card>
</template>

<script>
export default {
  name: "ci-jobs-table",
  props: {
    jobs: {
      type: Array,
      required: true
    }
  }
}
</script>

<style scoped>

</style>
